import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import LinterRuleResults
  from 'Views/Page/Content/Templates/WhatIfTemplate/Components/LinterRuleResultsDrawer/LinterRuleResults';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import {
  useLinterDrawerContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/LinterDrawer/LinterDrawerContext';

const styles = theme => ({
  drawerPaper: {
    width: 500,
    display: 'flex',
    flexDirection: 'column',
  },
  drawerHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 0, 2, 2),
    backgroundColor: theme.palette.common.white,
    position: 'sticky',
    top: 0,
  },
});

const LinterDrawer = ({
  classes,
}) => {
  const { pageContentResource, setPageContentCollection } = usePageContentContext();

  const { isOpen, closeLinterDrawer } = useLinterDrawerContext();

  const onCloseLinterDialog = (refreshPageResource = true) => {
    if (refreshPageResource) {
      pageContentResource?.relationship(fr.relationships.runAnalysis.name)?.link('related').get().then((resp) => {
        setPageContentCollection(resp);
      });
    }
  };

  return (
    <Drawer
      anchor={'right'}
      open={isOpen}
      ModalProps={{
        onBackdropClick: () => closeLinterDrawer(onCloseLinterDialog),
      }}
      PaperProps={{ className: classes.drawerPaper }}
    >
      <div className={classes.drawerHeader}>
        <IconButton
          aria-label={'toggle-linter-results-sidebar-visibility'}
          title={'Collapse Sidebar'}
          onClick={() => closeLinterDrawer(onCloseLinterDialog)}
          icon={CloseIcon}
          test="facet-plan-linter-drawer-close"
        />
      </div>
      <LinterRuleResults handleCloseDialog={() => closeLinterDrawer()} />
    </Drawer>
  );
};

LinterDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinterDrawer);
